import React from 'react';
import PropTypes from 'prop-types';
import { Document, Page } from 'react-pdf';
import Authorization from './../Authorization';

class ToolkitElement extends React.PureComponent {
  render() {
    return (
      <div className="pdf-view">
        <Authorization denied="guest">
          <a href={this.props.pdf} target="_blank">
            <div className="document-hover">
              <p className="document-hover__text">Has clic para visualizar</p>
            </div>
            <Document
              file={{
              url: this.props.pdf,
            }}
            >
              <Page pageNumber={1} renderTextLayer={false} />
            </Document>
          </a>
        </Authorization>
        <Authorization allowed="guest">
          <div className="to-hover">
            <div className="document-hover">
              <p className="document-hover__text">Debes contar con un plan para poder visualizar el documento</p>
            </div>
            <Document
              file={{
                url: this.props.pdf,
              }}
            >
              <Page pageNumber={1} renderTextLayer={false} />
            </Document>
          </div>
        </Authorization>
      </div>
    );
  }
}

ToolkitElement.propTypes = {
  pdf: PropTypes.string.isRequired,
};

export default ToolkitElement;



// WEBPACK FOOTER //
// ./src/components/ToolkitElement/index.js